/*
 * CAT - Cambiar la talla de un producto directamente desde el carrito.
 *
 * Al cambiar el <select> de talla de una linea del carrito:
 *   1) agrega la nueva variante (misma cantidad),
 *   2) elimina la linea anterior,
 *   3) refresca el carrito con el evento nativo 'cart:update' (el
 *      cart-items-component vuelve a renderizar su seccion; funciona en la
 *      pagina del carrito y en el drawer, sin recargar).
 * Si algo falla, recarga la pagina como respaldo.
 *
 * Usa delegacion de eventos en document y un guard global, por lo que se
 * inicializa una sola vez aunque el snippet se vuelva a renderizar.
 */
(function () {
  if (window.__catCartSizeChangeInit) return;
  window.__catCartSizeChangeInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var base = root.replace(/\/$/, '');

  function post(path, data) {
    return fetch(base + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data),
    });
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    var select = target && target.closest ? target.closest('[data-cat-cart-size-select]') : null;
    if (!select) return;

    var newId = select.value;
    var lineKey = select.getAttribute('data-line-key');
    var qty = parseInt(select.getAttribute('data-quantity'), 10) || 1;
    if (!newId || !lineKey) return;

    var changer = select.closest('[data-cat-size-changer]');
    select.disabled = true;
    if (changer) changer.classList.add('is-loading');

    post('/cart/add.js', { items: [{ id: Number(newId), quantity: qty }] })
      .then(function (res) {
        if (!res.ok) throw new Error('add.js ' + res.status);
        return post('/cart/change.js', { id: lineKey, quantity: 0 });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('change.js ' + res.status);
        document.dispatchEvent(
          new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } })
        );
      })
      .catch(function (err) {
        console.error('[cat-cart-size-change]', err);
        window.location.reload();
      });
  });
})();
